import { render, staticRenderFns } from "./WholesalesSearchEngineTable.vue?vue&type=template&id=67c2a23d&scoped=true&"
import script from "./WholesalesSearchEngineTable.vue?vue&type=script&lang=js&"
export * from "./WholesalesSearchEngineTable.vue?vue&type=script&lang=js&"
import style0 from "./WholesalesSearchEngineTable.vue?vue&type=style&index=0&id=67c2a23d&scoped=true&lang=css&"
import style1 from "../../../assets/css/style-tables-dark.css?vue&type=style&index=1&id=67c2a23d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c2a23d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCard,VCardText,VCardTitle,VDataTable,VSkeletonLoader,VSpacer})
